module.exports = __webpack_public_path__ + "static/media/Knight-horse012_2c.036f8d44.svg";